import type { ReactElement } from 'react';

import STYLES from './PageNotFoundImage.module.scss';

type Props = {
  altText: string;
};

const PageNotFoundImage = ({ altText }: Props): ReactElement => (
  <img
    alt={altText}
    src="https://content.skyscnr.com/m/3bd6e265b57135ea/original/SDCRT-1130_Illus_Launch_02_FlightsDbook_22_Error_404.svg"
    className={STYLES['page-not-found-image']}
  />
);

export default PageNotFoundImage;
